define(
  [
    'app',
    'underscore',
    './templates/index.html',
    'libs/models/UserCollection',
    './views/UserList'
  ],
  function (app, _, mentionTpl, UserCollection, UserList) {
    return app.Marionette.LayoutView.extend({
      template: mentionTpl,

      regions: {
        users: '.js-user-list'
      },

      options: {
        waitToFetch: 300,
        userItemRowHeight: 60
      },

      ui: {
        container: '.mention',
        search: 'input',
        users: '.js-user-list'
      },

      events: {
        'blur @ui.container': 'onBlur',
        'keyup @ui.search': 'onKeyUp',
        'keydown @ui.search': 'onKeyDown'
      },

      onKeyDown: function (e) {
        var code = e.keyCode

        if (code !== 38 && code !== 40 && code !== 13 && code !== 27) {
          return true
        }

        e.stopPropagation()
        e.preventDefault()

        var users = this.getRegion('users').currentView

        // Up
        if (code === 38) return users.selectPrev()

        // Down
        if (code === 40) return users.selectNext()

        // Enter
        if (code === 13) return this.select()
      },

      onKeyUp: function (e) {
        e.stopPropagation()

        var code = e.keyCode
        var handleInKeyDown = [38, 40, 13]

        if (handleInKeyDown.indexOf(code) > -1) return false

        // Esc
        if (e.keyCode === 27) {
          return this.hideMention()
        }

        var search = this.ui.search.val()
        this.localSearch(search)

        if (search.length > 2) {
          this.remoteSearch(search)
        }
      },

      select: function () {
        this.getRegion('users').currentView.children.each(function (view) {
          if (view.model.get('selected')) {
            view.model.set('selected', false)
            view.trigger('user:select', view.model)
          }
        })
      },

      localSearch: function (search) {
        search = search.toLowerCase()
        this.collection.each(function (model) {
          var modelNameLowerCase = model.get('name').toLowerCase()
          var isAMatch = modelNameLowerCase.indexOf(search) > -1
          model.set({
            visible: isAMatch,
            selected: false
          })
        })
        var firstVisible = this.collection.findWhere({ visible: true })
        if (firstVisible) {
          firstVisible.set('selected', true)
        }
      },

      remoteSearch: function (search) {
        var data = {
          query: search
        }
        if (this.options.topicId) data.topic_id = this.options.topicId
        this.collection.fetch({
          data: data
        })
      },

      onBlur: function () {
        this.blurTimeout = setTimeout(this.hideMention.bind(this), 300)
      },

      showMention: function () {
        clearTimeout(this.blurTimeout)
        this.ui.search.focus()
        this.remoteSearch()
      },

      hideMention: function () {
        this.ui.search.val('')
        this.trigger('hide')
      },

      onRender: function () {
        var region = this.getRegion('users')
        var self = this
        region.show(
          new UserList({
            collection: this.collection,
            userItemRowHeight: this.options.userItemRowHeight
          })
        )

        this.listenTo(region.currentView, 'user:select', function (model) {
          self.trigger('user:select', model)
          self.hideMention()
        })
      },

      initialize: function (options) {
        if (this.getOption('waitToFetch')) {
          this.remoteSearch = _.throttle(
            this.remoteSearch.bind(this),
            this.getOption('waitToFetch'),
            {
              leading: true,
              trailing: true
            }
          )
        }
        this.collection = new UserCollection(options.users || [])
      }
    })
  }
)
